import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fieldset-toggle"
export default class extends Controller {
  static targets = ["enabledField", "fieldset"];

  enabledFieldTargetConnected(element) {
    if (element.checked) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.fieldsetTarget.classList.remove("hidden");
  }

  hide() {
    this.fieldsetTarget.classList.add("hidden");
  }
}
